import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-4 col-sm-6" }
const _hoisted_6 = { class: "form-group mb-4" }
const _hoisted_7 = { value: 0 }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-lg-4 col-sm-6" }
const _hoisted_10 = { class: "form-group mb-4" }
const _hoisted_11 = { value: 0 }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-lg-4 col-sm-6" }
const _hoisted_15 = { class: "form-group mb-4" }
const _hoisted_16 = { value: 0 }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-lg-4 col-sm-6" }
const _hoisted_19 = { class: "form-group mb-4 position-relative" }
const _hoisted_20 = {
  key: 0,
  class: "dropdown-menu show w-100 mt-1",
  style: {"top":"100%","left":"0"}
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "col-lg-2 col-sm-6 text-end mt-4" }
const _hoisted_23 = { class: "d-inline-flex flex-wrap gap-3 justify-content-end" }
const _hoisted_24 = { class: "default-table-area style-two default-table-width" }
const _hoisted_25 = { class: "table-responsive" }
const _hoisted_26 = { class: "table align-middle" }
const _hoisted_27 = { class: "text-body" }
const _hoisted_28 = { class: "text-body" }
const _hoisted_29 = { class: "text-body text-center" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "text-body" }
const _hoisted_32 = { class: "text-body" }
const _hoisted_33 = { class: "text-body" }
const _hoisted_34 = { class: "text-body" }
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = { class: "" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "p-4 pt-lg-4" }
const _hoisted_39 = {
  id: "mdlContenido",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlContenidoLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  size: "large"
}
const _hoisted_40 = { class: "modal-dialog modal-xl" }
const _hoisted_41 = { class: "modal-content" }
const _hoisted_42 = { class: "modal-header" }
const _hoisted_43 = {
  class: "modal-title fs-5",
  id: "mdlContenidoLabel"
}
const _hoisted_44 = { class: "modal-body" }
const _hoisted_45 = { class: "default-table-area style-two default-table-width" }
const _hoisted_46 = { class: "table-responsive" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = ["src"]
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverlayLoader, { visible: _ctx.isLoading }, null, 8 /* PROPS */, ["visible"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label text-secondary strong" }, "Torneo", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.tournamentId) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getMatchesByTournament()))
                  }, [
                    _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.LABELS.SELECT), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsTournament, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: i
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_8))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.tournamentId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label text-secondary strong" }, "Partido", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.matchId) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getTeamsByTournament()))
                  }, [
                    _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.LABELS.SELECT), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsMatch, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: i
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_12))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.matchId]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label text-secondary" }, "Equipo", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.teamId) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example",
                    onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onChangeTeam && _ctx.onChangeTeam(...args)))
                  }, [
                    _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.LABELS.SELECT), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsTeam, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: i
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_17))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.teamId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "label text-secondary" }, "Nombre del Jugador", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.name) = $event)),
                    onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.fetchResults && _ctx.fetchResults(...args))),
                    type: "text",
                    class: "form-control",
                    placeholder: "Escribe para buscar jugadores..."
                  }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelText, _ctx.filters.name]
                  ]),
                  (_ctx.showDropdown && _ctx.results.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: item.id,
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.selectItem(item))
                          }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_21))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.getPlays(_ctx.currentPage)), ["prevent"])),
                    class: "btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                  }, " Buscar ")
                ])
              ])
            ])
          ], 32 /* NEED_HYDRATION */)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("table", _hoisted_26, [
              _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "#"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Jugador"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Jugada"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Estado"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode(" Creado"),
                    _createElementVNode("br"),
                    _createTextVNode(" por ")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode("creación")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Modificado "),
                    _createElementVNode("br"),
                    _createTextVNode("por")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode(" Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode(" modificación ")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Opciones")
                ])
              ], -1 /* HOISTED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1 + (_ctx.currentPage - 1) * _ctx.pageSize), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_27, _toDisplayString(item.player), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_28, _toDisplayString(item.play), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_29, [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (_ctx.confirmChangeStatus(item.id, item.isActive)),
                        class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeStatusClass(item.isActive)]),
                        role: "button"
                      }, _toDisplayString(item.isActive ? _ctx.STATUS.ACTIVE : _ctx.STATUS.INACTIVE), 11 /* TEXT, CLASS, PROPS */, _hoisted_30)
                    ]),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(item.createdBy), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(item.createdAtDateTimeString), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_33, _toDisplayString(item.updatedBy), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_34, _toDisplayString(item.updatedAtDateTimeString), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("button", {
                          class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                          onClick: ($event: any) => (_ctx.contentModal(item))
                        }, [...(_cache[16] || (_cache[16] = [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " settings ", -1 /* HOISTED */)
                        ]))], 8 /* PROPS */, _hoisted_37)
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_Pagination, {
              currentPage: _ctx.currentPage,
              pageSize: _ctx.pageSize,
              totalItems: _ctx.totalItems,
              "onUpdate:page": _ctx.fetchPage
            }, null, 8 /* PROPS */, ["currentPage", "pageSize", "totalItems", "onUpdate:page"])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Modal Contenido"),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("h1", _hoisted_43, " Jugada " + _toDisplayString(_ctx.objContent.play), 1 /* TEXT */),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", _hoisted_44, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "position-relative mb-3" }, null, -1 /* HOISTED */)),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                (_ctx.objContent.contentFileName != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      (!_ctx.objContent.isPDF)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.objContent.contentFileName,
                            class: "img-fluid mb-2 d-block"
                          }, null, 8 /* PROPS */, _hoisted_48))
                        : (_openBlock(), _createElementBlock("iframe", {
                            key: 1,
                            src: _ctx.objContent.contentFileName,
                            width: "100%",
                            height: "700px"
                          }, null, 8 /* PROPS */, _hoisted_49))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger text-white",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, " Cerrar ")
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}